<div class="edit-page-root-container expense-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{getTitle()}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" *ngIf="editForm" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" appCodeInput
                                        [readonly]="expenseInfo.id!==undefined && expenseInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')"> code
                                        should be entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Expense name
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>

                        </div>
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                                200.</mat-error>
                        </mat-form-field>
                        <div class="input-box-right">
                            <mat-form-field class="Week-NO">
                                <mat-label>Expense Type</mat-label>
                                <input matInput formControlName="expense_type" [matAutocomplete]="expenseTypeAuto"
                                    (input)="filterExpenseTypes()" (focus)="filterExpenseTypes(true)"
                                    autocomplete="off">
                                <button *ngIf="editForm.get('expense_type')?.value" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="clearExpenseType()">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-autocomplete #expenseTypeAuto="matAutocomplete"
                                    [displayWith]="displayExpenseType.bind(this)">
                                    <mat-option *ngFor="let et of filteredExpenseTypes" [value]="et">
                                        {{ et.name }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="editForm.get('expense_type')?.hasError('invalidExpenseType')">
                                    Please select a valid expense type.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>







            </form>
        </div>
    </div>
</div>